import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskReportsCustomTimeScaleRoute } from '@atlassian/jira-router-routes-servicedesk-reports-routes/src/servicedeskReportsCustomTimeScaleRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import CustomReports, { LazyServicedeskReportsCustom } from './ui/custom/index.tsx';

export const servicedeskReportsCustomTimeScaleRouteEntry = createEntry(
	servicedeskReportsCustomTimeScaleRoute,
	() => ({
		group: 'servicedesk',
		component: CustomReports,
		perfMetricKey: 'service-management.reports.custom',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsCustom],
		ufoName: 'service-management-custom-reports',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-reports-entries/src/servicedeskReportsCustomTimeScaleRouteEntry.tsx',
				whichExportToUse: 'servicedeskReportsCustomTimeScaleRouteEntry',
			},

			enabled: true,
		},
	}),
);
